"use client";;
import {
  AlignVerticalSpaceAroundIcon,
  ChevronsDownUpIcon,
  EqualIcon,
  MinusIcon,
} from "lucide-react";
import * as React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const rowHeights = [{
  label: "Short",
  value: "short",
  icon: MinusIcon,
}, {
  label: "Medium",
  value: "medium",
  icon: EqualIcon,
}, {
  label: "Tall",
  value: "tall",
  icon: AlignVerticalSpaceAroundIcon,
}, {
  label: "Extra Tall",
  value: "extra-tall",
  icon: ChevronsDownUpIcon,
}];

export function DataGridRowHeightMenu(
  {
    table,
    rowHeight: rowHeightProp,
    onRowHeightChange: onRowHeightChangeProp,
    ...props
  }
) {
  // NOTE: `rowHeight` lives in the useDataGrid internal store, not TanStack table state.
  // That means consumers must pass it down (or subscribe) to force re-renders.
  const rowHeight = rowHeightProp ?? table.options.meta?.rowHeight;
  const onRowHeightChange =
    onRowHeightChangeProp ?? table.options.meta?.onRowHeightChange;

  const selectedRowHeight = React.useMemo(() => {
    return (rowHeights.find((opt) => opt.value === rowHeight) ?? {
      label: "Short",
      value: "short",
      icon: MinusIcon,
    });
  }, [rowHeight]);

  return (
    <Select value={rowHeight} onValueChange={onRowHeightChange}>
      <SelectTrigger size="sm" className="h-8 w-auto gap-2">
        <div className="flex items-center gap-2">
          <selectedRowHeight.icon className="size-4 text-muted-foreground" />
          <span className="text-sm">{selectedRowHeight.label}</span>
        </div>
        <span className="sr-only">
          <SelectValue placeholder="Row height" />
        </span>
      </SelectTrigger>
      <SelectContent {...props}>
        {rowHeights.map((option) => {
          const OptionIcon = option.icon;
          return (
            <SelectItem key={option.value} value={option.value}>
              <OptionIcon className="size-4" />
              {option.label}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
